export default __webpack_public_path__ + "static/media/GBS.c1ad6d96.svg";